import {
  SERVICES_SUCCESS
} from '../actions/services'

export default function (state = {}, action) {
  switch (action.type) {
    case SERVICES_SUCCESS:
      return {
        ...state,
        ids: action.payload.result
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/services.js